// extracted by css-extract-rspack-plugin
export default {"sidebar":"sidebar--co89hkVKwi0rNwPN"};